import { useQuery } from '@tanstack/react-query'

import { useApiContext } from '../context/ApiContext'

export function useBlockedUsers() {
  const { apiClient } = useApiContext()

  return useQuery(['blocked-users'], () => apiClient.getBlockedUsers(), { retry: 2 })
}
